import {ExternalLinksZIndexes} from "../../../services/external-links/external-links-z-indexes";

export enum ConfettiZIndex {
    AboveEverything = ExternalLinksZIndexes.BurnOutAnimation
}

export interface IConfettiComponentProps {
    coordinates?: {left: number; top: number;};
    /**
     * Normally we wouldn't need a property to start, we would just render the component if we need to show the confetti
     * But rendering the confetti with display: none and triggering the animation with display: unset / initial / block; seems to help with performance
     * We don't need to alter display on all animated elements, changing just the container box is enough
     */
    zIndex?: number | ConfettiZIndex;
    animate: boolean;
}
